module.exports = __webpack_public_path__ + "static/media/filledForward.e5b49a67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/filledForward.svg
// module id = 41
// module chunks = 0